@let _metas = details.metas;
@let _schema = details.schema;
@if (details.initialType == 'string' && _schema.format == 'template') {
    <p-panel [toggleable]="true" [collapsed]="_isNulled ? true : undefined" class="with-borders w-full">
        <ng-template #header>
            <div class="hcol-flex gap-half align-center">
                @if (details.nullable && details.readOnly !== true) {
                    <p-checkbox
                        [binary]="true"
                        [(ngModel)]="_isNulledInv"
                        (onChange)="toggleNullable()"
                        [disabled]="jsonSchemaForm.readOnly"
                    ></p-checkbox>
                }
                <span class="p-panel-title">{{ _label }}</span>
            </div></ng-template
        >
        <div [style]="{minWidth: '30rem', minHeight: '30rem'}">
            @if (_metas.allowHtml === true) {
                <p-editor
                    [id]="_id"
                    [name]="_id"
                    [(ngModel)]="target[targetKey]"
                    [readonly]="jsonSchemaForm.readOnly || _isNulled || details.readOnly === true"
                    [style]="{minWidth: '30rem', minHeight: '30rem'}"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValidity()"
                >
                    @if (jsonSchemaForm.readOnly || _isNulled) {
                        <ng-template #header> </ng-template>
                    }
                </p-editor>
            } @else {
                <textarea
                    [id]="_id"
                    [name]="_id"
                    [(ngModel)]="target[targetKey]"
                    [readonly]="jsonSchemaForm.readOnly || _isNulled || details.readOnly === true"
                    [style]="{minWidth: '30rem', minHeight: '30rem'}"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValidity()"
                ></textarea>
            }
        </div>
    </p-panel>
} @else if (details.initialType == 'string' && !details.rowReference && !_schema.enum && _schema.format != 'date') {
    <p-inputgroup>
        @if (details.nullable && details.readOnly !== true) {
            <p-inputgroup-addon>
                <p-checkbox
                    [binary]="true"
                    [(ngModel)]="_isNulledInv"
                    (onChange)="toggleNullable()"
                    [disabled]="jsonSchemaForm.readOnly"
                ></p-checkbox>
            </p-inputgroup-addon>
        }

        @if (_isSecretMasked) {
            <p-floatlabel variant="on">
                <label [for]="_id" [attr.data-required]="_isRequiredComputed ? true : null">{{ _label }}</label>
                <input pInputText [id]="_id" type="password" value="**********" disabled />
                <p-inputgroup-addon>
                    <p-button
                        icon="pi pi-pencil"
                        [text]="true"
                        [disabled]="jsonSchemaForm.readOnly || details.readOnly === true"
                        (onClick)="unlockSecret()"
                        [disabled]="
                            jsonSchemaForm.readOnly ||
                            _isNulled ||
                            details.readOnly === true ||
                            details.writeOnly === true
                        "
                    ></p-button>
                </p-inputgroup-addon>
            </p-floatlabel>
        } @else {
            <p-floatlabel variant="on">
                @switch (_schema.format) {
                    @default {
                        <input
                            pInputText
                            [id]="_id"
                            [name]="_id"
                            [type]="details.isSecret ? 'password' : 'text'"
                            [pTooltip]="details.schema.description"
                            [minlength]="_schema.minLength ?? null"
                            [maxlength]="_schema.maxLength ?? null"
                            [pattern]="_schema.pattern ?? '[^\n]+'"
                            [required]="_isRequiredComputed"
                            [(ngModel)]="target[targetKey]"
                            [disabled]="jsonSchemaForm.readOnly || _isNulled || details.readOnly === true"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="updateValidity()"
                        />
                    }
                }
                @if (_schema.format == 'color') {
                    <p-inputgroup-addon
                        ><p-colorpicker
                            [id]="_id"
                            dataType="string"
                            [(ngModel)]="target[targetKey]"
                            appendTo="body"
                            [style]="{width: '1.5rem'}"
                            [disabled]="jsonSchemaForm.readOnly || _isNulled || details.readOnly === true"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="updateValidity()"
                        ></p-colorpicker
                    ></p-inputgroup-addon>
                }
                <label [for]="_id" [attr.data-required]="_isRequiredComputed ? true : null">{{ _label }}</label>
            </p-floatlabel>
        }
    </p-inputgroup>
} @else if (details.initialType == 'string' && _schema.format == 'date') {
    <p-inputgroup>
        @if (details.nullable && details.readOnly !== true) {
            <p-inputgroup-addon>
                <p-checkbox
                    [binary]="true"
                    [(ngModel)]="_isNulledInv"
                    (onChange)="toggleNullable()"
                    [disabled]="jsonSchemaForm.readOnly"
                ></p-checkbox>
            </p-inputgroup-addon>
        }
        <p-floatlabel variant="on">
            <p-datepicker
                [id]="_id"
                [showTime]="true"
                [showIcon]="true"
                [required]="_isRequiredComputed"
                [fluid]="true"
                dataType="date"
                appendTo="body"
                [(ngModel)]="target[targetKey]"
                [disabled]="jsonSchemaForm.readOnly || _isNulled || details.readOnly === true"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="updateValidity()"
            ></p-datepicker>
            <label [for]="_id" [attr.data-required]="_isRequiredComputed ? true : null">{{ _label }}</label>
        </p-floatlabel>
    </p-inputgroup>
} @else if (details.initialType == 'string' && details.rowReference) {
    <p-inputgroup>
        @if (details.nullable && details.readOnly !== true) {
            <p-inputgroup-addon>
                <p-checkbox
                    [binary]="true"
                    [(ngModel)]="_isNulledInv"
                    (ngModelChange)="toggleNullable()"
                    [disabled]="jsonSchemaForm.readOnly"
                ></p-checkbox>
            </p-inputgroup-addon>
        }
        <p-floatlabel variant="on">
            <p-select
                [id]="_id"
                [autoDisplayFirst]="false"
                [options]="jsonSchemaForm.context.rowReferencesOptions[details.rowReference.key]"
                optionLabel="label"
                optionValue="key"
                [required]="_isRequiredComputed"
                [pTooltip]="_schema.description"
                [(ngModel)]="target[targetKey]"
                [filter]="true"
                appendTo="body"
                [disabled]="jsonSchemaForm.readOnly || _isNulled || details.readOnly === true"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="updateValidity()"
            />
            <label [for]="_id" [attr.data-required]="_isRequiredComputed ? true : null">{{ _label }}</label>
        </p-floatlabel>
    </p-inputgroup>
} @else if (details.initialType == 'string' && _schema.enum) {
    <p-inputgroup>
        @if (details.nullable && details.readOnly !== true) {
            <p-inputgroup-addon>
                <p-checkbox
                    [binary]="true"
                    [(ngModel)]="_isNulledInv"
                    (ngModelChange)="toggleNullable()"
                    [disabled]="jsonSchemaForm.readOnly"
                ></p-checkbox>
            </p-inputgroup-addon>
        }
        <p-floatlabel variant="on">
            <p-select
                [id]="_id"
                [autoDisplayFirst]="false"
                [options]="_schema.enum"
                [required]="_isRequiredComputed"
                [pTooltip]="_schema.description"
                [(ngModel)]="target[targetKey]"
                [filter]="true"
                appendTo="body"
                [disabled]="jsonSchemaForm.readOnly || _isNulled || details.readOnly === true"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="updateValidity()"
            />
            <label [for]="_id" [attr.data-required]="_isRequiredComputed ? true : null">{{ _label }}</label>
        </p-floatlabel>
    </p-inputgroup>
} @else if (details.initialType == 'boolean') {
    <p-inputgroup>
        @if (details.nullable && details.readOnly !== true) {
            <p-inputgroup-addon>
                <p-checkbox
                    [binary]="true"
                    [(ngModel)]="_isNulledInv"
                    (onChange)="toggleNullable()"
                    [disabled]="jsonSchemaForm.readOnly"
                ></p-checkbox>
            </p-inputgroup-addon>
        }

        <p-floatlabel variant="on">
            <p-select
                [id]="_id"
                [pTooltip]="_schema.description"
                [autoDisplayFirst]="false"
                [options]="_booleanOptions"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [(ngModel)]="target[targetKey]"
                [disabled]="jsonSchemaForm.readOnly || _isNulled || details.readOnly === true"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="updateValidity()"
            ></p-select>
            <label [for]="_id" [attr.data-required]="_isRequiredComputed ? true : null">{{ _label }}</label>
        </p-floatlabel>
    </p-inputgroup>
} @else if (details.initialType == 'integer') {
    <p-inputgroup>
        @if (details.nullable && details.readOnly !== true) {
            <p-inputgroup-addon>
                <p-checkbox
                    [binary]="true"
                    [(ngModel)]="_isNulledInv"
                    (onChange)="toggleNullable()"
                    [disabled]="jsonSchemaForm.readOnly"
                ></p-checkbox>
            </p-inputgroup-addon>
        }
        <p-floatlabel variant="on">
            <p-inputnumber
                [id]="_id"
                mode="decimal"
                [useGrouping]="false"
                [min]="_schema.minimum"
                [max]="_schema.maximum"
                [required]="_isRequiredComputed"
                [pTooltip]="_schema.description"
                [fluid]="true"
                [(ngModel)]="target[targetKey]"
                [disabled]="jsonSchemaForm.readOnly || _isNulled || details.readOnly === true"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="updateValidity()"
            />
            <label [for]="_id" [attr.data-required]="_isRequiredComputed ? true : null">{{ _label }}</label>
        </p-floatlabel>
    </p-inputgroup>
} @else if (details.initialType == 'number') {
    <p-inputgroup>
        @if (details.nullable && details.readOnly !== true) {
            <p-inputgroup-addon>
                <p-checkbox
                    [binary]="true"
                    [(ngModel)]="_isNulledInv"
                    (onChange)="toggleNullable()"
                    [disabled]="jsonSchemaForm.readOnly"
                ></p-checkbox>
            </p-inputgroup-addon>
        }
        <p-floatlabel variant="on">
            <p-inputnumber
                [id]="_id"
                mode="decimal"
                [useGrouping]="false"
                [min]="_schema.minimum"
                [max]="_schema.maximum"
                [minFractionDigits]="1"
                [maxFractionDigits]="10"
                [required]="_isRequiredComputed"
                [pTooltip]="_schema.description"
                [fluid]="true"
                [(ngModel)]="target[targetKey]"
                [disabled]="jsonSchemaForm.readOnly || _isNulled || details.readOnly === true"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="updateValidity()"
            />
            <label [for]="_id" [attr.data-required]="_isRequiredComputed ? true : null">{{ _label }}</label>
        </p-floatlabel>
    </p-inputgroup>
} @else if (details.initialType == 'object') {
    <p-panel
        [toggleable]="!_metas.noParentFrame"
        [collapsed]="_metas.frameDefaultCollapsed || (_isNulled ? true : undefined)"
        class="w-full"
        [class.with-borders]="!_metas.noParentFrame"
        [class.no-header]="_metas.noParentFrame"
    >
        <ng-template #header>
            @if (!_metas.noParentFrame || details.nullable) {
                <div class="hcol-flex gap-half align-center">
                    @if (details.nullable && details.readOnly !== true) {
                        <p-checkbox
                            [binary]="true"
                            [(ngModel)]="_isNulledInv"
                            (onChange)="toggleNullable()"
                            [disabled]="jsonSchemaForm.readOnly"
                        ></p-checkbox>
                    }
                    <span class="p-panel-title">{{ _label }}</span>
                </div>
            }
        </ng-template>
        @if (details.sub && details.sub.tabs.length > 1) {
            <div class="mb-3">
                <p-tabs [(value)]="_activeTab">
                    <p-tablist>
                        @for (tab of details.sub.tabs; track tab) {
                            <p-tab [value]="tab">{{ tab }}</p-tab>
                        }
                    </p-tablist>
                </p-tabs>
            </div>
        }
        @if (target[targetKey] !== null && target[targetKey] !== undefined && details.sub) {
            <div class="hcol-flex gap-half">
                @for (currentCol of details.sub.columns[_activeTab]; track currentCol.index) {
                    <div class="floatingLabelContainer" [style]="currentCol.style">
                        @for (prop of currentCol.properties; track prop.id) {
                            <app-json-schema-form-property
                                [jsonSchemaForm]="jsonSchemaForm"
                                [path]="path + '.' + prop.id"
                                [name]="prop.id"
                                [details]="prop"
                                [target]="target[targetKey]"
                                [targetKey]="prop.id"
                                [parentKeys]="parentKeys + '[' + targetKey + ']'"
                                [style.display]="prop.writeOnly === true ? 'none' : undefined"
                                (validityChangedEvent)="queueValidityPropagation()"
                            ></app-json-schema-form-property>
                        }
                    </div>
                }
            </div>
        }
    </p-panel>
} @else if (details.initialType == 'array') {
    @let isTags = _schema.format == 'tags' && details.arrayItemType?.type === 'string';
    <p-panel
        [header]="_label"
        [toggleable]="!_metas.noParentFrame"
        [collapsed]="_metas.frameDefaultCollapsed"
        class="w-full"
        [class.with-borders]="!_metas.noParentFrame"
        [class.no-header]="_metas.noParentFrame"
    >
        @if (_schema.format == 'table' && details.arrayItemType?.type === 'object' && details.tableSub) {
            <p-table
                [value]="target[targetKey]"
                stripedRows
                showGridlines
                [scrollable]="true"
                [paginator]="true"
                [rows]="10"
                [rowsPerPageOptions]="[10, 25]"
                [resizableColumns]="true"
                [autoLayout]="true"
                columnResizeMode="expand"
                scrollHeight="flex"
                [tableStyle]="{'min-width': '50rem'}"
            >
                <ng-template #header>
                    <tr>
                        <th scope="col" pFrozenColumn [frozen]="true" style="width: 2rem"></th>
                        @for (prop of details.tableSub; track prop) {
                            <th
                                scope="col"
                                pResizableColumn
                                [style.display]="prop.writeOnly === true ? 'none' : undefined"
                            >
                                <b>{{ prop.label }}</b>
                            </th>
                        }
                        @if (details.readOnly !== true) {
                            <th scope="col" alignFrozen="right" pFrozenColumn [frozen]="true" style="width: 2rem"></th>
                        }
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="50">
                            <p-message severity="warn">There is nothing to show.</p-message>
                        </td>
                    </tr>
                </ng-template>

                <ng-template #body let-current let-rowIndex="rowIndex">
                    <tr [pReorderableRow]="rowIndex">
                        <td pFrozenColumn [frozen]="true" style="vertical-align: baseline">
                            <span class="pi pi-bars" pReorderableRowHandle></span>
                        </td>
                        @for (prop of details.tableSub; track prop) {
                            <td
                                style="vertical-align: baseline"
                                [style.display]="prop.writeOnly === true ? 'none' : undefined"
                            >
                                <div class="hcol-100 floatingLabelContainer">
                                    <app-json-schema-form-property
                                        [jsonSchemaForm]="jsonSchemaForm"
                                        [path]="path + '[' + rowIndex.toString() + ']' + '.' + prop.id"
                                        [name]="prop.id"
                                        [details]="prop"
                                        [target]="target[targetKey][rowIndex]"
                                        [targetKey]="prop.id"
                                        [parentKeys]="parentKeys + '[' + targetKey + ']' + '[' + rowIndex + ']'"
                                        (validityChangedEvent)="queueValidityPropagation()"
                                    ></app-json-schema-form-property>
                                </div>
                            </td>
                        }
                        @if (details.readOnly !== true) {
                            <td alignFrozen="right" pFrozenColumn [frozen]="true" style="vertical-align: baseline">
                                <p-button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    (onClick)="delArrayElement(rowIndex)"
                                    [disabled]="jsonSchemaForm.readOnly"
                                />
                            </td>
                        }
                    </tr>
                </ng-template>
            </p-table>
        } @else if (isTags) {
            @if (target[targetKey]) {
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 0.2rem">
                    @for (k of target[targetKey]; track $index) {
                        <p-chip
                            #chip
                            [label]="k"
                            [removable]="details.readOnly !== true && !jsonSchemaForm.readOnly"
                            (onRemove)="delArrayElement($index); chip.visible = true"
                        ></p-chip>
                    }
                </div>
            }
        } @else {
            @if (target[targetKey]) {
                @for (arrayElement of target[targetKey]; track $index) {
                    <div class="hcol-flex gap-half mb-2">
                        <div class="hcol-100 floatingLabelContainer">
                            <app-json-schema-form-property
                                [jsonSchemaForm]="jsonSchemaForm"
                                [path]="path + '[' + $index.toString() + ']'"
                                [name]="name + ' #' + ($index + 1)"
                                [details]="details.arrayItemProperty!"
                                [target]="target[targetKey]"
                                [targetKey]="$index"
                                [parentKeys]="parentKeys + '[' + targetKey + ']'"
                                [style.display]="details.writeOnly === true ? 'none' : undefined"
                                (validityChangedEvent)="queueValidityPropagation($event)"
                            ></app-json-schema-form-property>
                        </div>
                        @if (details.readOnly !== true) {
                            <div style="vertical-align: baseline">
                                <div>
                                    <p-button
                                        icon="pi pi-trash"
                                        severity="danger"
                                        (onClick)="delArrayElement($index)"
                                        [disabled]="jsonSchemaForm.readOnly"
                                    />
                                </div>
                            </div>
                        }
                    </div>
                }
            }
        }
        @if (details.readOnly !== true) {
            <p-button
                icon="pi pi-plus"
                size="small"
                (onClick)="addArrayElement()"
                [disabled]="jsonSchemaForm.readOnly"
            />
        }
    </p-panel>
}
